<template>
  <div>
    <div class="school-list">
      <div class="title" v-if="!isAreaList">直属学校列表</div>
      <div class="title" v-else>中心校学校列表</div>
      <div class="state-box" v-if="!isAreaList">
        <div class="pitch-on"></div>
        <div class="no-pitch-on" @click="alterState"></div>
      </div>
      <div class="state-box" v-else>
        <div class="no-pitch-on" @click="alterState"></div>
        <div class="pitch-on"></div>
      </div>
      <div v-if="!isAreaList" class="rate-content">
        <div
          class="rate-list"
          ref="rateItem"
          v-for="(item, index) in schoolList"
          :key="index"
          @click="clickRow(item, index)"
        >
          <div class="rate-name">{{ item.schoolName }}</div>
        </div>
        <div class="total-content" v-if="schoolList.length > 16">
          <span> 共有{{ schoolList.length }}所学校!<br />暂无更多~ </span>
        </div>
        <div class="noData" v-if="schoolList.length == 0">
          暂无数据
        </div>
      </div>
      <div v-else class="rate-content">
        <div
          class="rate-list-two"
          ref="rateItem"
          v-for="(item, index) in areaSchoolList"
          :key="index"
          @click="unfoldState(item)"
        >
          <div class="rate-list-box">
            <div class="rate-name">{{ item.eduBuresuName }}</div>
            <div
              v-if="!item.isUnfold"
              class="rate-icon el-icon-arrow-right"
            ></div>
            <div v-else class="rate-icon el-icon-arrow-down"></div>
          </div>
          <div v-show="item.isUnfold">
            <div
              v-show="item.schools.length > 0"
              class="rate-area-list"
              v-for="(iitem, iindex) in item.schools"
              :ref="'rateAreaItem' + index + iindex"
              :key="iindex"
              @click.stop="areaSchoolClick(iitem, index, iindex)"
            >
              <div class="rate-area-name">
                {{ iitem.schoolName }}
              </div>
            </div>
            <div v-show="item.schools.length == 0" class="rate-area-list">
              <div class="rate-area-name">
                暂无数据~
              </div>
            </div>
          </div>
        </div>
        <div class="total-content" v-if="areaSchoolList.length > 16">
          <span> 共有{{ areaSchoolList.length }}所中心校!<br />暂无更多~ </span>
        </div>
        <div class="noData" v-if="areaSchoolList.length == 0">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "schoolList",
  props: {
    schoolList: {
      type: Array,
      default: {
        return: []
      }
    },
    areaSchoolList: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data() {
    return {
      isAreaList: false
    };
  },
  methods: {
    clickRow(row, index) {
      this.$emit("clickRow", row);
      this.$refs.rateItem.map((item) => {
        return (item.className = "rate-list");
      });
      this.$refs.rateItem[index].className = "rate-list-pitch-on";
    },
    alterState() {
      this.isAreaList = !this.isAreaList;
    },
    unfoldState(row) {
      row.isUnfold = !row.isUnfold;
    },
    areaSchoolClick(row, index, iindex) {
      let refsStr = "rateAreaItem" + index + iindex;
      this.areaSchoolList.forEach((zItem, zIndex) => {
        zItem.schools.forEach((xItem, xIndex) => {
          let refsStrTwo = "rateAreaItem" + zIndex + xIndex;
          this.$refs[refsStrTwo][0].className = "rate-area-list";
        });
      });
      this.$refs[refsStr][0].className = "rate-list-pitch-on";
      // console.log(this.$refs[refsStr]);
      this.$emit("clickRow", row);
    }
  }
};
</script>
<style scoped lang="scss">
.school-list {
  margin-top: 10px;
  padding: 7px 20px 0px 20px;
  width: calc(100% + 10px);
  width: 100%;
  background: url("~@/assets/img/eduBigRisk2/right-bottom-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    height: 20px;
    color: #6ff3fa;
  }
  .state-box {
    height: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/img/schoolBigData/no-pitch-on-state.png") center
      center no-repeat;
    .pitch-on {
      width: 70px;
      height: 100%;
      background: url("~@/assets/img/schoolBigData/pitch-on-state.png") center
        center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .no-pitch-on {
      width: 70px;
      height: 100%;
      cursor: pointer;
    }
  }
  .rate-content {
    margin-top: 10px;
    width: 100%;
    height: 440px;
    overflow: scroll;
    scrollbar-width: none;
  }
  .rate-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    height: 38px;
    text-align: center;
    background: rgba(17, 165, 215, 0.2);
    border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    &:nth-child(2n) {
      background: rgba(17, 165, 215, 0.05);
    }
    .rate-name {
      flex: 0 0 100%;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4cdff;
      line-height: 22px;
      text-align: center;
    }
    &:nth-child(1) {
      .rate-score {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 22px;
        background: linear-gradient(180deg, #edefff 0%, #fff04d 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    &:nth-child(2) {
      .rate-score {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 22px;
        background: linear-gradient(180deg, #edefff 0%, #4d76ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    &:nth-child(3) {
      .rate-score {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #8e6236 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .rate-list-two {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    .rate-list-box {
      display: flex;
      flex-direction: row;
      background: rgba(17, 165, 215, 0.2);
      flex: 0 0 100%;
      &:nth-child(2n) {
        color: red;
      }
      .rate-name {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 38px;
        text-align: center;
        width: 100%;
      }
      .rate-icon {
        margin-top: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        color: white;
      }
    }
    .rate-area-list {
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      .rate-area-name {
        margin-top: 8px;
        flex: 0 0 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c4cdff;
        line-height: 38px;
        height: 38px;
        text-align: center;
      }
    }
  }
  //   直属学校条数信息
  .total-content {
    width: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    margin-top: 20px;
    img {
      margin-left: 37.5%;
      width: 25%;
      opacity: 0.8;
    }
    span {
      margin-left: 35%;
      width: 30%;
      color: rgba(233, 237, 255, 0.8);
    }
  }
}

.rate-list-pitch-on {
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  background-image: linear-gradient(
    to left,
    rgba(39, 209, 237, 0),
    rgba(28, 188, 227, 1),
    rgba(17, 165, 215, 0)
  );
  margin-bottom: 8px;
  .rate-name {
    flex: 0 0 100%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffff00;
    line-height: 38px;
    height: 38px;
    text-align: center;
  }
  .rate-area-name {
    margin-top: 8px;
    flex: 0 0 100%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffff00;
    line-height: 38px;
    text-align: center;
  }
}
.noData {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
</style>
